/**
 * Size chart modal behaviour: Measurements / How To Measure tabs and the in <-> cm switch.
 *
 * The theme's modal clones `#modal-fit-guide-chart` into the global modal on open, so all
 * handlers are delegated at document level and scoped to the nearest `.fgc` root.
 * Markup: snippets/fit-guide-chart.liquid. Styles: assets/custom.css.
 */
(function () {
  'use strict';

  var INCH_TO_CM = 2.54;

  function toCm(inch) {
    var value = Number(inch);
    return isFinite(value) ? (value * INCH_TO_CM).toFixed(1) : '';
  }

  // A range cell carries data-inch-min / data-inch-max; a single value carries data-inch.
  function cmLabel(cell) {
    var min = cell.getAttribute('data-inch-min');
    var max = cell.getAttribute('data-inch-max');
    if (min !== null && max !== null) return toCm(min) + '–' + toCm(max);
    return toCm(cell.getAttribute('data-inch'));
  }

  // Handlers are document-wide, so the target may be a non-element node (document, text).
  function closestFrom(target, selector) {
    return target instanceof Element ? target.closest(selector) : null;
  }

  function selectTab(root, tabName) {
    var tabs = root.querySelectorAll('[data-fgc-tab]');
    var panels = root.querySelectorAll('[data-fgc-panel]');
    var i;

    for (i = 0; i < tabs.length; i++) {
      tabs[i].setAttribute('aria-selected', tabs[i].getAttribute('data-fgc-tab') === tabName ? 'true' : 'false');
    }
    for (i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-fgc-panel') !== tabName;
    }
  }

  function applyUnit(root, useCm) {
    var cells = root.querySelectorAll('[data-fgc-val]');

    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      cell.textContent = useCm ? cmLabel(cell) : cell.getAttribute('data-inch-label');
    }
    root.classList.toggle('fgc--cm', useCm);
  }

  document.addEventListener('click', function (event) {
    var tab = closestFrom(event.target, '[data-fgc-tab]');
    if (!tab) return;

    var root = tab.closest('.fgc');
    if (!root) return;

    event.preventDefault();
    selectTab(root, tab.getAttribute('data-fgc-tab'));
  });

  document.addEventListener('change', function (event) {
    var toggle = closestFrom(event.target, '[data-fgc-unit]');
    if (!toggle) return;

    var root = toggle.closest('.fgc');
    if (!root) return;

    applyUnit(root, toggle.checked);
  });
})();
